import React from 'react'

import { LntCheckbox, LntSelect } from '@app/components/base'
import { TopFilters as TopFiltersWrapper } from '@app/components'

import { LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'

import { getTypes } from '@app/api/routes/monitorings'
import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'
import { getRegions } from '@app/api/routes/locationRegions'

import { FILTERS_PLACEHOLDERS, statusMonitoringTasksOptions } from '@app/constants/filters'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'

import { useFiltersSearch } from '@app/hooks'
import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { FilterPeriod, useFilterPeriod } from '@app/features/filterPeriod'

import { commonSelectProps } from './configs'

import type { TopFilterProps } from './types'

export const TopFilters: React.FC<TopFilterProps> = ({ onSearch, initialFilters }) => {
  const {
    filters,
    canResetFilters,
    setFilters,
    handleClearFilters,
    handleSearch,
    handleSelectFilterChange,
    handleCheckboxChange,
    handleWeekChange
  } = useFiltersSearch({ initialFilters, onSearch })

  const { isWeekSelected, selectedPeriodParam, handleClear, handlePeriodChange, handleRangeDateChange } =
    useFilterPeriod({ filters, setFilters, onSearch, handleClearFilters })

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClear }
      onSearch={ handleSearch }
    >
      <LntSelect
        { ...commonSelectProps }
        value={ filters.monitoringTypeIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.monitoringTypeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
        querySelect={ {
          queryKey: [MONITORINGS_TYPES_KEY.typesItems],
          queryFn: getTypes,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.storeIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.storeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationStoresItems],
          queryFn: getStores,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clusterIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.clusterIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.salesOrganizationIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.regions }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.regions, value) }
        placeholder={ FILTERS_PLACEHOLDERS.regionsFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationRegionsItems],
          queryFn: getRegions,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.status }
        options={ statusMonitoringTasksOptions }
        onChange={ value => handleSelectFilterChange(FILTERS_PARAMS_KEYS.status, value) }
        placeholder={ FILTERS_PLACEHOLDERS.status }
      />

      <FilterPeriod
        filters={ filters }
        isWeekSelected={ isWeekSelected }
        selectedPeriodParam={ selectedPeriodParam }
        onWeekChange={ handleWeekChange }
        onPeriodChange={ handlePeriodChange }
        onRangeDateChange={ handleRangeDateChange }
      />

      <LntCheckbox
        value={ filters.showStopped }
        onChange={ handleCheckboxChange(FILTERS_PARAMS_KEYS.showStopped, true) }
      >
        Отображать остановленные
      </LntCheckbox>
    </TopFiltersWrapper>
  )
}
